import clone from 'lodash.clonedeep'
import IVideoConfig from '../@types/IVideoConfig'
import { NEWRELIC_APPLICATION_ID } from '../constants/newrelic'
import AppEvent from '../enums/AppEvent'
import { getBaseData, parseAdError } from './eventParsers'

export function record(
  event: AppEvent,
  config: IVideoConfig,
  data?: any
): void {
  if (
    !window.$mediavine ||
    !window.$mediavine.newrelic ||
    window.$mediavine.newrelic.info.applicationID !== NEWRELIC_APPLICATION_ID ||
    config.site.disable_newrelic
  ) {
    console.log('Skipping metrics')
    return
  }

  const send = window.$mediavine.newrelic.addPageAction
  const cfg = clone(config) // newrelic is impure

  try {
    switch (event) {
      case AppEvent.imaLoaded:
      case AppEvent.imaStart:
      case AppEvent.initIMA:
      case AppEvent.initLauncher:
      case AppEvent.initPlacement:
      case AppEvent.initPlayer:
      case AppEvent.initVJS:
      case AppEvent.vjsEnded:
      case AppEvent.vjsError:
      case AppEvent.vjsLoadedData:
        send(event, getBaseData(cfg))
        break
      case AppEvent.vjsAdsError:
        send(event, parseAdError(data, cfg))
        break
      default:
        console.log('Tried to record unknown event:', event)
    }
  } catch (err) {
    console.error('NewRelic.addPageAction error: ', err)
  }
}
